module.exports = __webpack_public_path__ + "media/V43.6a835ca5.mp4";